import { isEmpty } from 'lodash-es';
import { IGlobalJobSearchFilterDTO } from 'wisestep-api';

import { IHotJobsSearchFilters, IHotJobsAdvancedFilters } from '../listing/types/IHotJobsSearch';

import { dateBeforeDays } from './HotJobsDefaultQuery';

const mapVisaStatus = (visa: string) => {
  if (visa === 'CITIZEN') return ['CITIZEN', 'USC'];
  else return [visa];
};

export const constructHotJobsQuery = (
  data: IHotJobsSearchFilters & IHotJobsAdvancedFilters,
  prevQuery: IGlobalJobSearchFilterDTO
) => {
  const updatedQuery = prevQuery;
  updatedQuery.search = data.query ?? '';
  updatedQuery.locations = data.locations;
  updatedQuery.visas = data.visaStatus
    ? data.visaStatus === 'All'
      ? undefined
      : mapVisaStatus(data.visaStatus)
    : undefined;
  updatedQuery.postedFromDate = dateBeforeDays(data.postedInBetweenDays ?? 30);
  updatedQuery.includeJobWithoutVisa = data.includeJobsWithoutVisas ?? true;
  if (!isEmpty(data.jobTitles)) {
    // updatedQuery.search +=
    //   (!isEmpty(updatedQuery.search) ? ',' : '') + `${data.jobTitles?.join(',')}`;
    updatedQuery.title = data.jobTitles ?? [];
  }

  return { ...updatedQuery };
};
